import { Component, ViewChild, ChangeDetectorRef, OnInit } from '@angular/core';
import {
  IonicPage, NavController, AlertController, ModalController, ToastController,
  LoadingController, Loading, Content, Platform, PopoverController, Searchbar, Events
} from 'ionic-angular';
import { FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Page } from '../../enums/page.enum';
import { CustomerModel } from '../../models/customer/customer.model';
import { ShiptoModel } from '../../models/customer/shipto.model';
import { SalesOrgModel } from '../../models/customer/salesorg.model';
import { PayerModel } from '../../models/customer/payer.model';
import { OrderHeaderModel } from '../../models/order/orderheader.model';
import { OrderReasonModel } from '../../models/order/orderreason.model';
import { CustomerMOVSurchargeModel } from '../../models/customer/customerMOVSurcharge.model';
import { ContractModel } from '../../models/contract/contract.model';

/* Filters & Services */
import { CustomerService } from '../../services/customer.service';
import { TransactionService } from '../../services/transaction.service';
import { UtilService } from '../../services/util.service';
import { BadgeService } from '../../services/badge.service';
import { StorageService } from '../../services/storage.service';
import { UserService } from '../../services/user.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
// import { AuthService } from '../../services/auth.service';
import { MsalService } from '@azure/msal-angular';

/* lodash */
import * as _ from "lodash";
import { Setups } from '../../services/setup';
import { ModalAction } from '../../enums/modalaction.enum';
import { SalesInd } from '../../enums/salesind.enum'
import { SettingId } from '../../enums/settingid.enum';
import { ImpersonateUser, UserModel } from '../../models/user/user.model';
import { UserType } from '../../enums/usertype.enum'

import { Errors } from '../../services/apperror';
import { SalesrepModel } from '../../models/user/salesrep.model';
import { AuthWrapper } from '../../infra/authWrapper';

@IonicPage()
@Component({
  selector: 'customer',
  templateUrl: 'customer.html'
})
export class Customer implements OnInit {
  @ViewChild(Content) content: Content;
  @ViewChild('searchbar') searchbar: Searchbar;

  // showsurvey: boolean= false;
  // CCLIORDER-1638- NPS survey implementation
  safeNpsSurveyUrl: SafeResourceUrl;
  isbrowserrefresh: boolean = false;
  loading: Loading;
  customer: CustomerModel[] = [];
  term = new FormControl();
  oriCustomer: CustomerModel[] = [];
  oriPageIndex: number = 0;

  shipto: ShiptoModel[];
  salesorg: SalesOrgModel[];
  payer: PayerModel[];
  searchTerm: string = "";
  bottomPixel: string;
  direction: string;
  pageIndex: number = 0;
  showScrollToTop: Boolean = false;
  custRoute: string = '';

  isFirstLoad: Boolean = true;
  orderTypeName: string = "";
  orderReasonList: OrderReasonModel[] = [];
  selectedOrderReason: string;
  isVN: Boolean = false;
  isAllowAdhocCustomerInsertion: Boolean = false;
  settingId = SettingId;
  custRestrictionPolicy: string = "";

  constructor(
    private storage: Storage
    , private platform: Platform
    , private changeDetectorRef: ChangeDetectorRef
    , private events: Events
    , public navCtrl: NavController
    , public modalCtrl: ModalController
    , private alertCtrl: AlertController
    , private loadingCtrl: LoadingController
    , public popoverCtrl: PopoverController
    , private toastCtrl: ToastController
    , private customerService: CustomerService
    , private transactionService: TransactionService
    , private badgeService: BadgeService
    , private storageService: StorageService
    , private userService: UserService
    , private util: UtilService
    , private domSanitizer: DomSanitizer
    , private setups: Setups
    , private msalService: MsalService
    , private authWrapper: AuthWrapper
  ) {
    // Remove DKSH logo
    this.isVN = this.util.isRemoveDKSHLogoForVN();

    // Amend order reason for CONSIGNMENT order
    // Can only trigger by burger menu
    events.subscribe('change-tab-params', async (tab: number, params: any) => {        
      if (tab == Page.CustomerList) {       
        if (params.salesInd === SalesInd.CONSIGNMENT) {         
          // CCLI-3035---show order reason popup when user click burger menu from customer page.
          let currentTab= this.navCtrl.parent.getSelected().index;
          this.storageService.salesInd= params.salesInd;        
          if(currentTab== Page.CustomerList){
           this.selectOrderReason();
          }          
        } else {
          this.storageService.clearCustomer(); /// TIC0951396---
          this.storageService.clearOrder();
          this.storageService.setSalesInd(params.salesInd);
          this.retrieveCustomerList();
          await this.storage.set("orderReason", "");
          this.selectedOrderReason = "";
        }
      }

      if (tab == Page.OrderList) {
            if (params.salesInd !== "C") {
                await this.storage.set("orderReason", "");
                this.selectedOrderReason = "";
            }
            this.storageService.setSalesInd(params.salesInd);
            this.retrieveCustomerList(undefined, this.searchTerm, params.salesInd);
        }
    });
  }

  ionViewWillEnter() {
    if (!this.authWrapper.isAuthenticated()) {
      this.authWrapper.unAuthenticatedRedirect();
      return;
    }
    
    // CCLI-3035---This code will only be executed when the user navigates to the Customer page and the user session is already established  
    this.storage.get('user').then(
      (user: UserModel) => {
          if (!_.isEmpty(user)) { 
            this.selectOrderReason(); 
          }

          // CCLIORDER-1638- NPS survey implementation
          if (user.survey_nps_url !== '') {
            this.safeNpsSurveyUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(user.survey_nps_url + "?id=" + user.user_id + "&name=" + user.user_name + "&email=" + user.email + "&country=" + user.country_code);
          }

          const adHocSetup = user.setup_list.find(obj => {
            return obj.setup_code === this.setups.AllowAdhocCustomerInsertion.ID
          });

          if (adHocSetup == null || adHocSetup == undefined) {
            this.isAllowAdhocCustomerInsertion = false;
          } else {
            this.isAllowAdhocCustomerInsertion = adHocSetup.setup_value === "0" ? false : true;
          }
        }
    );
  }

  ngOnInit() {
    if (!this.authWrapper.isAuthenticated()) {
      this.authWrapper.unAuthenticatedRedirect();
      return;
    }

    this.populateBottomPixel();

    this.storage.get('user').then(
      (user: UserModel) => {
        if (_.isEmpty(user) === false
            && _.isEmpty(user.salesrep_list) === false) {
          this.storageService.setFromSession().then(() => {
            this.retrieveCustomerList();
            this.displayFeedBackAndSummaryOrder();
          });
        }
      }
    );
  }

  searchCustomer() {
    this.retrieveCustomerList(undefined, "");

  }

  private displayFeedBackAndSummaryOrder() {
    if (this.storageService.getSetupValue(this.setups.AllowLogoutLoginSummaryOrder.ID) === "1") {
      this.getSummaryOrder();
    } else {
      this.showFeedbackPopup();
    }
  }

  showFeedbackPopup(){
    this.storage.get('user').then((user) => {
      if (user) {
        if(user.survey_nps_url != "" && user.survey_completed_status == 0){
          let feedbackModal = this.modalCtrl.create('CustomerFeedback',   { enableBackdropDismiss: false });
          feedbackModal.present();
          feedbackModal.onDidDismiss((p) => {
              switch (p.action) {
                  case "cancel":
                      return;
                  case "proceed":
                      return
              }
          }) 
        } else {
          return;
        }
      }
    });
  }

  getSummaryOrder() {
    let summaryModal = this.modalCtrl.create('LogoutSummaryOrder', {}, { cssClass:'summary-modal', enableBackdropDismiss: false });
    summaryModal.present();
    summaryModal.onDidDismiss((p) => {
        switch (p.action) {
            case "cancel":
                this.showFeedbackPopup();
                return;
        }
    })
  }

  reloadPage(refresher) {
    this.retrieveCustomerList();
    refresher.complete();
  }

  copyUrlonClipboard(ev: any, custid: any) {
    ev.stopPropagation();
    var myCode = custid;
    var fullLink = document.createElement('input');
    document.body.appendChild(fullLink);
    // fullLink.value = "http://healthcare.imind.dksh.co.th/imind-consent/Form2.aspx?code=" + myCode;
    fullLink.value = "https://hec-imind.dksh.co.th/imind-consent/Form2.aspx?code=" + myCode;
    fullLink.select();
    document.execCommand("copy", false);
    fullLink.remove();
    this.util.displayToast(this.toastCtrl, "Link Copied");
  }

  displayMap(ev: any, customer: CustomerModel) {
    ev.stopPropagation();
    let AddressMapModal = this.modalCtrl.create('AddressMap',
      { address: customer.address },
      { enableBackdropDismiss: false }
    );

    AddressMapModal.present();
    AddressMapModal.onDidDismiss((data) => {
    })
  }

  loadCustomerOnScroll(infiniteScroll) {
    this.retrieveCustomerList(infiniteScroll);
  }

  async retrieveCustomerList(infiniteScroll?: any, searchTerm?: string, salesInd?: string) {
    if (!navigator.onLine) {
      this.util.displayAlert(this.alertCtrl, "No internet", "There's no internet connection.");
      return;
    }

    if (infiniteScroll == undefined) {
      this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Preparing request data");
      this.pageIndex = 0; /* Reset back to 0 */
    }

    searchTerm = (this.searchTerm !== "" ? this.searchTerm : "");

    // TODO: Why we need to amend order reason again when init page, the order reason already updated?
    if (salesInd == undefined && this.storageService.getSalesInd() !== SalesInd.CONSIGNMENT) {
      this.selectedOrderReason = "";
    }

    if (salesInd == undefined && this.storageService.getSalesInd() === SalesInd.CONSIGNMENT) {
      this.selectedOrderReason = this.storageService.getOrder().order_reason;
    }

    if (this.storageService.getSalesInd() === SalesInd.CONSIGNMENT) {
      if (this.selectedOrderReason === "" || this.selectedOrderReason == undefined) {
        let orderreason = await this.storage.get("orderReason");
        this.selectedOrderReason = orderreason;
      }
    }

    var selectedOrderReason = (this.selectedOrderReason !== "" ? this.selectedOrderReason : "");

    this.customerService.retrieveCustomerList(this.pageIndex, this.storageService.getSalesrepCode(), this.searchTerm.trim(), this.custRoute, selectedOrderReason, this.storageService.getSettingId())
      .subscribe(
        (data) => {
          this.pageIndex++;
          if (infiniteScroll == undefined)
            this.customer = data;
          else {
            infiniteScroll.complete();
            this.customer = this.customer.concat(data);
          }
          let itemsInMobilePage = this.storageService.getItemsInMobilePage();
          this.util.checkHideFooter(data.length, (this.searchTerm != "" && this.customer.length <= itemsInMobilePage) ? 'down' : this.direction);

          this.customer.forEach(function (val) {
            val.order_reason = selectedOrderReason;
          })
        },
        (err) => {
          if (infiniteScroll !== undefined)
            infiniteScroll.complete();
            this.util.processError(this.loading, this.alertCtrl, err);
        },
        () => {
          if (infiniteScroll === undefined) {
            this.loading.dismiss();
          }
          this.isFirstLoad = false;
        })
  }

  redirectCustDtl(custInfo: CustomerModel) {
    this.navCtrl.push('CustomerDetail', custInfo);
  }

  async redirectPrdList(custInfo: CustomerModel) {
    custInfo.order_reason = await this.storage.get('orderReason');
    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Checking for previous session's order");

    let order: OrderHeaderModel;
    order = await this.storage.get('order');

    this.transactionService.retrieveTempOrder(this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId())
      .subscribe(
        (data) => {
          this.loading.dismiss();
          if (data.txn_no !== null) {
            if (order) {
              if (order.txn_no !== data.txn_no) {
                this.displayTempOrderConfirmation("Previous order found",
                  "You've a pending order from previous session. Do you wish to proceed with the previous order instead?", custInfo, data);
                return;
              }
            } else {
              this.displayTempOrderConfirmation("Previous order found",
                "You've a pending order from previous session. Do you wish to proceed with the previous order instead?", custInfo, data);
              return;
            }
          }
          this.retrieveCustomerSalesorgShiptoAndRedirectPrdList(custInfo);
        }, (err) => {
          this.loading.dismiss();
          this.util.displayToast(this.toastCtrl, "Unable to retrieve temp order!");
        }
      )
  }

  processPrevOrder(order: OrderHeaderModel) {
    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading order details");
    this.transactionService.retrieveTempOrderDetail(order.txn_no, this.storageService.getSettingId()).subscribe(
      (data) => {
        if (data) {
          order.detail = data;
          order.et_foc = order.et_foc;
          let customer: CustomerModel = new CustomerModel()
          , shipto: ShiptoModel = new ShiptoModel();
          shipto.code = order.shipto_code;
          shipto.name = order.shipto.name;
          shipto.add_1 = order.shipto.add_1;
          shipto.add_2 = order.shipto.add_2;
          shipto.add_3 = order.shipto.add_3;
          shipto.add_4 = order.shipto.add_4;
          shipto.city = order.shipto.city;
          shipto.province_code = order.shipto.province_code;
          shipto.province_name = order.shipto.province_name;
          shipto.postcode = order.shipto.postcode;

          customer.salesorg = <SalesOrgModel>{};
          customer.cust_code = order.soldto_code;
          customer.cust_name = order.soldto_name;

          // sales area
          customer.salesorg.salesorg = order.salesorg;
          customer.salesorg.distchannel = order.distchannel;
          customer.salesorg.division = order.division;

          customer.salesorg.shipto_list = [];
          customer.salesorg.shipto_list.push(shipto);

          // Payer
          customer.payer.payer_code = order.payer_code;
          customer.payer.cust_code = order.soldto_code;
          customer.pay_term_code = order.pay_term_code;
          customer.pay_term_name = order.pay_term_name;
          // TODO: Missing mat_grp4
          customer.order_reason = order.order_reason;
          //STRY0017537 [TH] Order save/ submission - pop up notification for copy of PO for government hospital start
          customer.salesorg.custClassfication = order.custClassfication
          //STRY0017537 [TH] Order save/ submission - pop up notification for copy of PO for government hospital end
          this.storage.remove('uploadedOrder');

          this.storageService.setCustomer(customer);
          this.storageService.setOrder(order);

          this.badgeService.resetBadgeAndCountOrder(order);

          this.storage.set('uploadedOrder', order).then(() => {
            this.events.publish('update-order-detail', "start", this.storageService.getToken());
            this.navCtrl.parent.select(Page.OrderList);
          });
        } else {
          this.loading.dismiss();
          this.util.displayToast(this.toastCtrl, "Unable to retrieve temp order!");
          return;
        }
      }, (err) => {
        this.loading.dismiss();
        this.util.displayToast(this.toastCtrl, "Unable to retrieve temp order!");
        return;
      }, () => {
        this.loading.dismiss();
      }
    )


  }

  retrieveCustomerSalesorgShiptoAndRedirectPrdList(custInfo: CustomerModel) {
    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading salesorg details");
    this.customerService.retrieveSalesOrgAndShiptoList(this.storageService.getSalesrepCode(), custInfo.cust_code, custInfo.order_reason, this.storageService.getSettingId())
      .subscribe(
        (res) => {
          this.salesorg = res;
          if (this.salesorg.length == 0) {
            this.util.displayAlert(this.alertCtrl, "Shipto not found",
              "There's no shipto found for the selected customer (" + custInfo.cust_code + " - " + custInfo.cust_name + ")");
          } else if (this.salesorg.length == 1 && this.salesorg[0].shipto_list.length == 1) {
            this.storage.get("selectedCustomer").then((_storageSelectedCustomer) => {
              custInfo.salesorg = this.salesorg[0];

              if (this.storageService.getSalesInd() == SalesInd.CONSIGNMENT) {
                this.storage.set("orderReason", custInfo.order_reason);
              }

              this.retrievePayerList(custInfo);
            });
          } else if (this.salesorg.length > 0) {
            //show modal
            custInfo.salesorg = this.salesorg[0];
            let SalesOrgModal = this.modalCtrl.create('CustomerSalesOrg',
              { customer: custInfo, salesOrgList: this.salesorg },
              { enableBackdropDismiss: false }
            );

            SalesOrgModal.present();
            SalesOrgModal.onDidDismiss((data) => {
              switch (data.action) {
                case ModalAction.Cancel:
                  return false;
                case ModalAction.Proceed:
                  custInfo.salesorg = data.salesOrg;
                  this.retrievePayerList(custInfo)
              }
            });
          } else {
            this.util.displayAlert(this.alertCtrl, "Salesorg not found", "There's no salesorg found for the selected customer (" + custInfo.cust_code + " - " + custInfo.cust_name + ")");
          }
        }, (err) => {
          this.util.processError(this.loading, this.alertCtrl, err);
        }, () => {
          this.loading.dismiss();
        }
      )
  }

  /**
   * Fetch payer_code from ws
   * @param custInfo 
   */
  async retrievePayerList(custInfo: CustomerModel) {
    this.custRestrictionPolicy = this.storageService.checkCustomerRestrictionPolicy();
    if (this.custRestrictionPolicy && this.custRestrictionPolicy.trim() !== "") {
        const isValid = await this.getCustomerRestriction(this.custRestrictionPolicy, custInfo.cust_code, custInfo.salesorg.salesorg, custInfo.salesorg.distchannel, custInfo.salesorg.division);
        if (!isValid) return;
    }

    this.customerService.retrievePayerList(this.storageService.getSalesrepCode(), custInfo.cust_code, custInfo.salesorg.salesorg, custInfo.salesorg.distchannel, custInfo.salesorg.division, this.storageService.getSettingId())
      .subscribe((payerData: PayerModel[]) => {
        if (_.isEmpty(payerData)) {
          this.util.displayAlert(this.alertCtrl, "Missing payer", "Payer is missing for this customer. Please contact support team for further assistance.");
          return;
        }

        this.payer = payerData;
        if (this.payer.length > 1) {
          this.showPayerPopup(custInfo);
        } else {
          if (_.isEmpty(this.payer[0].term) && this.storageService.getSalesInd() !== SalesInd.CONSIGNMENT) {
            this.util.displayAlert(this.alertCtrl, "Missing Payment Term", "Payer Payment Term is missing for this customer. Please contact support team for further assistance.");
            return;
          }

          custInfo.payer = this.payer[0];
          if (this.storageService.getSalesInd() === SalesInd.CONSIGNMENT) {
            custInfo.pay_term_code = 'Z999';
            custInfo.pay_term_name = 'Within 999 days Due Net';
          } else {
            custInfo.pay_term_code = this.payer[0].term;
            custInfo.pay_term_name = this.payer[0].payment_term_name;
          }

          if (this.storageService.getSalesInd() == SalesInd.CONSIGNMENT) {
            this.storage.set("orderReason", custInfo.order_reason);
          }

          this.navigateToProductList(custInfo);
        }
      }
    );
  }

  getCustomerRestriction(policy:string,custcode: string, salesOrg: string, distChannel:string, division:string ): Promise<boolean> {
    return this.customerService.getCustomerRestrictionPolicy(custcode,salesOrg,distChannel, division, this.storageService.getSettingId()).toPromise()
    .then(
      (data) => {
        let policies= policy.split(";")
        const creditBlock = data?.CreditBlockCode;
        const salesBlock = data?.SalesBlockCode;
        if (salesBlock && policies[0]=="1") {
          this.util.displayAlert(this.alertCtrl, "Customer Blocked", data?.BlockReasonDescription);
          return false;
        }
        if (creditBlock === "X" && policies[1]=="1") {
          this.util.displayAlert(this.alertCtrl, "Customer Blocked", "This customer has been blocked by Credit Management");
          return false;
        }
        
        return true;
      }
    )
    .catch((error) => {
      this.util.displayAlert(this.alertCtrl, "Error", "Unable to retrieve customer restriction policy. Please try again later.");
      return false;
      }
    );
  }

  viewFilterOpt(event: any) {
    let popOver = this.popoverCtrl.create('CustomerFilterPopover', { custRoute: this.custRoute });
    popOver.present({ ev: event });
    popOver.onDidDismiss((custRoute) => {
      this.custRoute = (custRoute ? custRoute : "");
      this.retrieveCustomerList(undefined, "");
    })
  }

  /**
   * Show payer popup for payment configuaration (customer has multiple payer_code)
   * @param custInfo 
   */
  showPayerPopup(custInfo: CustomerModel) {
    if (this.salesorg[0].cgcode !== "" && this.salesorg[0].cgcode != null && (this.salesorg[0].cgcode === "MK" || "G2" || "E1")) {
      let PayerModal = this.modalCtrl.create('CustomerPayer', { customer: custInfo, payerList: this.payer }, { enableBackdropDismiss: false });
      PayerModal.present();
      PayerModal.onDidDismiss((data) => {
        switch (data.action) {
          case ModalAction.Cancel:
            return false;
          case ModalAction.Proceed:
            if (_.isEmpty(data.payer.term) && this.storageService.getSalesInd() !== SalesInd.CONSIGNMENT) {
              this.util.displayAlert(this.alertCtrl, "Missing Payment Term", "Payer Payment Term is missing for this customer. Please contact support team for further assistance.");
              return;
            }

            if (this.storageService.getSalesInd() === SalesInd.CONSIGNMENT) {
              custInfo.pay_term_code = 'Z999';
              custInfo.pay_term_name = 'Within 999 days Due Net';
            } else {
              custInfo.payer = data.payer;
              custInfo.pay_term_code = data.payer.term;
              custInfo.pay_term_name = data.payer.payment_term_name;
            }

            this.navigateToProductList(custInfo);
            return;
        }
      });
    } else if (this.salesorg[0].cgcode === "") {
      let PayerModal = this.modalCtrl.create('CustomerPayer', { customer: custInfo, payerList: this.payer }, { enableBackdropDismiss: false });
      PayerModal.present();
      PayerModal.onDidDismiss((data) => {
        switch (data.action) {
          case ModalAction.Cancel:
            return false;
          case ModalAction.Proceed:
            if (_.isEmpty(data.payer.term)) {
              this.util.displayAlert(this.alertCtrl, "Missing Payment Term", "Payer Payment Term is missing for this customer. Please contact support team for further assistance.");
              return;
            }

            custInfo.payer = data.payer;
            custInfo.pay_term_code = data.payer.term

            this.navigateToProductList(custInfo);
            return;
        }
      });
    } else {
      this.util.displayAlert(this.alertCtrl, "Error", "Data not maintained correctly");
    }
  }

  populateBottomPixel() {
    if (this.platform.is('mobile') == true) {
      this.bottomPixel = "80px";
    }

    this.content.ionScrollEnd.subscribe((data) => {
      if (data == null) {
        this.showScrollToTop = false;
      }
      else {
        let itemsInMobilePage = this.storageService.getItemsInMobilePage();
        if (data['scrollTop'] > 0) { this.showScrollToTop = true; }
        else { this.showScrollToTop = false; }
        if (this.customer.length <= itemsInMobilePage) { this.util.checkHideFooter(this.customer.length, '') }
        else if (data['directionY'] == "up") { this.util.checkHideFooter(10, data['directionY']) }
        this.direction = data['directionY'];
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  scrollToTop() {
    this.content.scrollToTop();
  }

  /**
   * Navigate to product page. Store customer info in storage.
   * @param customer CustomerModel
   */
  async navigateToProductList(customer: CustomerModel) {
    customer.is_contract_customer = await this.checkCustomerContract(customer);
    customer.selected_contract = undefined;

    if (customer.is_contract_customer) {
      let contractList = await this.retrieveContractList(customer);
      if (contractList.length == 0) {
        customer.is_contract_customer = false;
      } else {
        // User can switch contract later on product list
        customer.selected_contract = contractList[0];
      }
    }

    this.storage.get('selectedCustomer').then((value) => {
      if (_.isEmpty(value)) {
        this.storage.set("selectedCustomer", customer).then(() => {
          this.events.publish('change-tab-params', Page.ProductList, false);
        });
      } else {
        if (this.util.isSameCustomer(customer, value)) {
          value.is_contract_customer = customer.is_contract_customer;
          // Keep the contract user already switched to on product list
          if (!customer.is_contract_customer || !value.selected_contract) {
            value.selected_contract = customer.selected_contract;
          }
          this.storage.set("selectedCustomer", value).then(() => {
            this.events.publish('change-tab-params', Page.ProductList, false);
          });
        } else {
          let arrButtons = [
            { text: 'Cancel', role: 'cancel', handler: () => { return true; } },
            {
              text: 'Confirm', handler: () => {
                this.transactionService.deleteTempOrder(this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId()).subscribe(
                  (data) => {
                    this.badgeService.resetBadge();
                    this.storageService.clearCustomer().then(() => {
                      this.storageService.clearOrder().then(() => {
                        this.storage.set("selectedCustomer", customer).then(() => {
                          this.events.publish('change-tab-params', Page.ProductList, false);
                        });
                      });
                    });
                  }
                );
              }
            }
          ]

          this.util.displayConfirmation(this.alertCtrl, "Confirmation", "You've already selected a customer. Do you wish to choose this customer instead? Any unsaved order will be lost.", arrButtons);
        }
      }
    });
  }

  displayTempOrderConfirmation(title: string, message: string, custInfo: CustomerModel, prevOrder: OrderHeaderModel) {
    let arrButtons = [{ text: 'Cancel', role: 'cancel', handler: () => { return true; } },
    {
      text: 'Discard', handler: () => {
        this.transactionService.deleteTempOrder(this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId()).subscribe();
        this.retrieveCustomerSalesorgShiptoAndRedirectPrdList(custInfo);
      }
    },
    { text: 'Proceed', handler: () => { this.processPrevOrder(prevOrder); } }]
    this.util.displayConfirmation(this.alertCtrl, title, message, arrButtons);
  }

  selectOrderReason() {
    let salesInd = this.storageService.getSalesInd();
    if (salesInd === SalesInd.CONSIGNMENT) {
      if (this.storageService.getSettingId() != SettingId.HK && this.storageService.getSettingId() != SettingId.SG) {
        this.customerService.retrieveOrderReasonList(this.storageService.getSalesrepCode(), this.storageService.getSettingId()).subscribe(
          (data) => {
            if (data.length > 0) {
             if(data.length== 1) {
                    this.storageService.clearCustomer(); /// TIC0951396---
                    this.storageService.clearOrder();
                    this.selectedOrderReason = data[0].order_reason_code;
                    this.storage.set("orderReason", data[0].order_reason_code)
                    this.storageService.setSalesInd(salesInd)
                    this.retrieveCustomerList(undefined, this.searchTerm, salesInd)
             }
             else{
              this.orderReasonList = data;
              let orderReasonModal = this.modalCtrl.create('OrderReason'
                , { data: this.orderReasonList }
                , { enableBackdropDismiss: false }
              );
              orderReasonModal.present();
              orderReasonModal.onDidDismiss((p) => {
                switch (p.action) {
                  case "cancel":
                    return;
                  case "proceed":
                    this.storageService.clearCustomer(); /// TIC0951396---
                    this.storageService.clearOrder();
                    this.selectedOrderReason = p.order_reason.order_reason_code;
                    this.storage.set("orderReason", p.order_reason.order_reason_code)
                    this.storageService.setSalesInd(salesInd);
                    this.retrieveCustomerList(undefined, this.searchTerm, salesInd);
                }
              })
             }
              
            } else {
              this.util.displayAlert(this.alertCtrl, "", "Not authorized to create consignment order (order reason not configured)");
            }
          });
        }
    }   
  }

  /**
   * Navigate to adhoc customer
   */
  async openSearchCustomer() {
    this.navCtrl.push('CustomerSearchPage');
  }

  /**
   * Delete adhoc customer
   * @param ev 
   * @param customer 
   */
  async onClickDeleteCustomer(ev: any, customer: CustomerModel) {
    ev.stopPropagation();
    const user: UserModel = this.storageService.getUser();

    let customerMappingDeleteModal = this.modalCtrl.create('CustomerMappingDeletePage', { selectedCustomer: customer, selectedSalesrepCode: user.salesrep_list[0].salesrep_code }, { enableBackdropDismiss: false, cssClass: '' });
    customerMappingDeleteModal.present();
    customerMappingDeleteModal.onDidDismiss((data) => {
        if (!!data) {
            if (!!data.action) {
                switch (data.action) {
                    case ModalAction.Cancel:
                      return false;
                    case ModalAction.Proceed:
                      return false;
                }
            } 
        } 
    });
  }
  
  /**
   * Contract order only applies to VN normal orders. On API failure, fall back to normal (non-contract) flow.
   */
  checkCustomerContract(customer: CustomerModel): Promise<boolean> {
    if (this.storageService.getSettingId() != SettingId.VN || this.storageService.getSalesInd() != SalesInd.NORMAL) {
      return Promise.resolve(false);
    }

    return new Promise<boolean>((resolve) => {
      this.customerService.checkCustomerContract(
        customer.cust_code
        , customer.salesorg.shipto_list[0].code
        , customer.salesorg.salesorg
        , customer.salesorg.distchannel
        , customer.salesorg.division
        , this.storageService.getSettingId()
      ).subscribe(
        (res) => resolve(res.data === true),
        (err) => {
          this.util.displayToast(this.toastCtrl, "Unable to check customer contract!");
          resolve(false);
        }
      );
    });
  }

  retrieveContractList(customer: CustomerModel): Promise<ContractModel[]> {
    return new Promise<ContractModel[]>((resolve) => {
      this.customerService.retrieveCustomerContractList(
        customer.cust_code
        , customer.salesorg.shipto_list[0].code
        , customer.salesorg.salesorg
        , customer.salesorg.distchannel
        , customer.salesorg.division
        , this.storageService.getSettingId()
      ).subscribe(
        (res) => resolve(res.data || []),
        (err) => {
          this.util.displayToast(this.toastCtrl, "Unable to retrieve customer contract list!");
          resolve([]);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer/customer.ts